import React from "react";
import { breakWord, dataFormatter } from "../../lib/utils";

const CustomModal = ({
  isOpen,
  onClose,
  title,
  data,
  exclude_fields = ["_id", "user_id"],
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="h-[80%] bg-white rounded-lg shadow-lg w-fit p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">{title}</h2>
          <button
            onClick={onClose}
            className="text-gray-600 hover:text-gray-900 focus:outline-none"
            aria-label="Close modal"
          >
            &#x2715;
          </button>
        </div>
        <div className="max-h-[80%] overflow-y-auto">
          {data && typeof data === "object" ? (
            <table className="max-w-min border border-gray-200">
              <thead>
                <tr className="bg-gray-100">
                  <th className="text-left px-4 py-2 border-b border-gray-200 font-medium text-gray-700">Field</th>
                  <th className="text-left px-4 py-2 border-b border-gray-200 font-medium text-gray-700">Value</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(data).map(
                  ([key, value]) =>
                    !exclude_fields.includes(key) && (
                      <tr key={key} className="border-b border-gray-200">
                        <td className="px-4 py-2 font-medium text-gray-700">{breakWord(key)}</td>
                        <td className="px-4 py-2 text-gray-900">{dataFormatter(value)}</td>
                      </tr>
                    )
                )}
              </tbody>
            </table>
          ) : (
            <p className="text-gray-500">No data available</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomModal;
